import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import { RiRobot2Fill } from 'react-icons/ri';

const Footer = () => {
  return (
    <footer className="bg-cyber-dark border-t border-cyber-purple/30">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <RiRobot2Fill className="h-8 w-8 text-cyber-pink animate-neon-pulse" />
              <span className="ml-2 text-xl font-orbitron font-bold relative neon-text" data-text="CyberNest">
                <span className="text-white">Cyber<span className="text-cyber-pink">Nest</span></span>
              </span>
            </div>
            <p className="text-gray-300 mt-2">
              Next-level web solutions with futuristic design and cutting-edge technology.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="https://facebook.com" className="text-cyber-neon hover:text-cyber-pink transition-colors">
                <FaFacebook className="h-6 w-6" />
              </a>
              <a href="https://twitter.com" className="text-cyber-neon hover:text-cyber-pink transition-colors">
                <FaTwitter className="h-6 w-6" />
              </a>
              <a href="https://instagram.com" className="text-cyber-neon hover:text-cyber-pink transition-colors">
                <FaInstagram className="h-6 w-6" />
              </a>
              <a href="https://linkedin.com" className="text-cyber-neon hover:text-cyber-pink transition-colors">
                <FaLinkedin className="h-6 w-6" />
              </a>
              <a href="https://github.com" className="text-cyber-neon hover:text-cyber-pink transition-colors">
                <FaGithub className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-cyber-pink font-orbitron text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-cyber-neon transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-cyber-neon transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-cyber-neon transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 hover:text-cyber-neon transition-colors">Pricing</Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-gray-300 hover:text-cyber-neon transition-colors">Portfolio</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-cyber-neon transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-cyber-pink font-orbitron text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/portfolio" className="text-gray-300 hover:text-cyber-neon transition-colors">Portfolio Websites</Link>
              </li>
              <li>
                <Link to="/services/business" className="text-gray-300 hover:text-cyber-neon transition-colors">Business Websites</Link>
              </li>
              <li>
                <Link to="/services/ecommerce" className="text-gray-300 hover:text-cyber-neon transition-colors">E-Commerce Stores</Link>
              </li>
              <li>
                <Link to="/services/landing" className="text-gray-300 hover:text-cyber-neon transition-colors">Landing Pages</Link>
              </li>
              <li>
                <Link to="/services/educational" className="text-gray-300 hover:text-cyber-neon transition-colors">Educational Platforms</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-cyber-pink font-orbitron text-lg font-bold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <p className="text-gray-300">
                123 Digital Avenue, <br />
                Tech District, 10101
              </p>
              <p className="text-gray-300">
                ankitmaharshi55@gmail.com
              </p>
              <p className="text-gray-300">
                +91-9468532536
              </p>
              <Link to="/contact" className="inline-block mt-4 cyber-button">
                <span>Get In Touch</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-cyber-purple/20">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              &copy; {new Date().getFullYear()} CyberNest Web Solutions. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-4 text-sm text-gray-300">
              <Link to="/privacy" className="hover:text-cyber-neon transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-cyber-neon transition-colors">Terms of Service</Link>
              <Link to="/sitemap" className="hover:text-cyber-neon transition-colors">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 